// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rLGc","title":"styles_title__3CRQq"};